import { render } from "./TextContainer.vue?vue&type=template&id=c0028472&scoped=true"
import script from "./TextContainer.vue?vue&type=script&lang=js"
export * from "./TextContainer.vue?vue&type=script&lang=js"

import "./TextContainer.vue?vue&type=style&index=0&id=c0028472&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0028472"]])

export default __exports__